"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var asg_1 = require("@alinta-digital/asg");
var TotalBalanceLabel_1 = tslib_1.__importDefault(require("../TotalBalanceLabel"));
var TotalBalanceAmt_1 = tslib_1.__importDefault(require("../TotalBalanceAmt"));
var DueDate_1 = tslib_1.__importDefault(require("../DueDate"));
var AccountBalance_constants_1 = require("../AccountBalance.constants");
var OverdueAccountBalance = function (props) {
    var totalBalance = props.totalBalance, dueDate = props.dueDate, overdueAmt = props.overdueAmt, hasDirectDebit = props.hasDirectDebit, hasSmoothPay = props.hasSmoothPay, hasPaymentExtension = props.hasPaymentExtension;
    var dueDateLabelProps = {
        dueDate: dueDate,
        hasDirectDebitSetup: hasDirectDebit && !hasSmoothPay,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(asg_1.Box, { direction: "row" },
            react_1.default.createElement(asg_1.Box, { width: "60%", alignSelf: "start" },
                react_1.default.createElement(asg_1.Text, { size: "small", "data-testid": "overdueBalanceLabel", weight: 600, color: asg_1.colors['status-error'] }, AccountBalance_constants_1.OVERDUE_PAY_NOW_LABEL)),
            react_1.default.createElement(asg_1.Box, { width: "40%", direction: "row" },
                react_1.default.createElement(asg_1.Text, { width: "100%", alignSelf: "start", textAlign: "end", size: "medium", "data-testid": "overdueAmount", weight: 600, color: asg_1.colors['status-error'] },
                    "$",
                    Math.abs(overdueAmt).toFixed(2)))),
        react_1.default.createElement(asg_1.Box, { direction: "row", margin: { top: '12px' } },
            react_1.default.createElement(asg_1.Box, { width: "50%", alignSelf: "start" },
                react_1.default.createElement(TotalBalanceLabel_1.default, null),
                (!hasPaymentExtension || hasDirectDebit) && react_1.default.createElement(DueDate_1.default, tslib_1.__assign({}, dueDateLabelProps))),
            react_1.default.createElement(asg_1.Box, { width: "50%", direction: "row" },
                react_1.default.createElement(TotalBalanceAmt_1.default, { totalBalance: totalBalance })))));
};
exports.default = OverdueAccountBalance;
//# sourceMappingURL=OverdueAccountBalance.js.map